import React, { useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { config } from '../config'
import secureLocalStorage from 'react-secure-storage';
import Swal from 'sweetalert2';

const Otp = () => {
    const [otp, setOtp] = useState('');
    const navigate = useNavigate();
    const onSubmitOtp = (e) => {
        e.preventDefault();
        console.log(secureLocalStorage?.getItem('otp'))
        if(otp == secureLocalStorage?.getItem('otp')){
            secureLocalStorage?.removeItem('otp');
            navigate(`${config.appUrl}apply-leave`);
        }else{
            Swal.fire({
                icon:'warning',
                text:"Oops! OTP Verification Failed 🚫",
            })
        }
    }


    return (
        <div>
            <div className='login-side text-center login-back'>
                <h3 className='mb-2'>Leave Management System</h3>
                <p>Please enter the One-Time Password sent to your registered contact to continue. </p>
                <form className='login-form mt-4 pt-3' onSubmit={onSubmitOtp}>
                    <div>
                        <div>
                            <label className='form-label'>Enter One-Time Password</label>
                            <div className=''>
                                <div className=''>
                                    <input type='text'
                                        placeholder='Enter OTP Received on Email'
                                        className='form-control custom-control '
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='mt-5 w-100'>
                            <button type='submit' className='leave-button text-decoration-none text-center'>Submit OTP</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Otp
